export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'qcJd7jY3DDfn7PlXmUhJpSLw4770JSsK',
        //dev auth0 clientId: 'PQzzOhpNXe1rBm9SEPhU69MrRZgX9jmt',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'qcJd7jY3DDfn7PlXmUhJpSLw4770JSsK',
        //dev auth0 clientId: 'PQzzOhpNXe1rBm9SEPhU69MrRZgX9jmt',
        audience: 'https://crew-time/api',
    }
}